import React from 'react'

const NotFound = () => {
    return (
        <div className='all-center'>
            <h1>Page Not Found</h1>
            <p className="lead">The page you are looking for does not exist...</p>
        </div>
    )
}
export default NotFound